import { useState } from 'react';
import { CMSAPI } from '../../services/index';

type CityResponse = string[];

export interface Office {
  fullName: string;
  officeId: string;
  intermediaryCode: string;
}

type OfficeResponse = Office[];

export const useCities = () => {
  const [cities, setCities] = useState<CityResponse>([]);
  const [offices, setOffices] = useState<OfficeResponse>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCities = async (searchText: string) => {
    try {
      setOffices([]);
      setLoading(true)
      setError(null)
      const res = await CMSAPI.get<CityResponse>(`offices/cities/?searchText=${searchText}`);
      if (res.length <= 1) {
        await fetchOffice(res.length ? res[0] : searchText);
      } else {
        setCities(res);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setCities([]);
      setError(`0 vestigingen gevonden bij jou in de buurt.`);
      setLoading(false);
    }
  };

  const fetchOffice = async (city: string) => {
    try {
      setLoading(true)
      setError(null)
      const res = await CMSAPI.get<OfficeResponse>(`offices/near?location=${city}`);
      setOffices(res)
      if (res.length === 0) {
        setError(`0 vestigingen gevonden bij jou in de buurt.`);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError(`0 vestigingen gevonden bij jou in de buurt.`);
      setLoading(false);
    }
  };

  return {cities, offices, error, loading, fetchCities, fetchOffice, setCities, setOffices};
};
